(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const currency = window.Shopify?.currency?.active || 'TND';
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format((cents || 0) / 100);
  const request = async (url, options = {}) => {
    const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json', ...(options.body ? { 'Content-Type': 'application/json' } : {}) }, ...options });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Something went wrong');
    return data;
  };
  const checkoutAttributionKey = 'noNameOrderAttribution';
  const readStorage = (storage, key) => {
    try { return window[storage]?.getItem(key) || null; } catch { return null; }
  };
  const writeStorage = (storage, key, value) => {
    try { window[storage]?.setItem(key, value); } catch { /* Shopify preview can block storage. */ }
  };
  const removeStorage = (storage, key) => {
    try { window[storage]?.removeItem(key); } catch { /* Shopify preview can block storage. */ }
  };
  const orderAttemptId = (storageKey) => {
    const existing = readStorage('sessionStorage', storageKey);
    if (existing) return existing;
    const id = crypto.randomUUID?.() || `${Date.now()}_${crypto.getRandomValues(new Uint32Array(4)).join('_')}`;
    writeStorage('sessionStorage', storageKey, id);
    return id;
  };
  const captureCheckoutAttribution = () => {
    const params = new URLSearchParams(window.location.search);
    const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'campaign_id', 'ad_id', 'fbclid', 'gclid', 'ttclid'];
    let saved = {};
    try { saved = JSON.parse(readStorage('localStorage', checkoutAttributionKey) || '{}'); } catch { saved = {}; }
    keys.forEach((key) => {
      const value = String(params.get(key) || '').trim();
      if (value) saved[key] = value.slice(0, 180);
    });
    if (!saved.landing_page) saved.landing_page = `${window.location.pathname}${window.location.search}`.slice(0, 300);
    if (!saved.referrer && document.referrer) saved.referrer = document.referrer.slice(0, 300);
    saved.last_page = `${window.location.pathname}${window.location.search}`.slice(0, 300);
    writeStorage('localStorage', checkoutAttributionKey, JSON.stringify(saved));
    return saved;
  };
  captureCheckoutAttribution();

  const brandIntro = $('[data-brand-intro]');
  if (brandIntro) {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sessionOnly = brandIntro.dataset.frequency !== 'always';
    const alreadySeen = sessionOnly && sessionStorage.getItem('noname-intro-seen');
    let introTimer;
    const finishBrandIntro = () => {
      if (sessionOnly) sessionStorage.setItem('noname-intro-seen', '1');
      document.body.classList.remove('st-intro-locked');
      brandIntro.classList.add('is-finished');
      window.setTimeout(() => brandIntro.remove(), 650);
      window.clearTimeout(introTimer);
    };
    if (reducedMotion || alreadySeen) {
      brandIntro.remove();
    } else {
      document.body.classList.add('st-intro-locked');
      introTimer = window.setTimeout(finishBrandIntro, Number(brandIntro.dataset.duration || 2800));
      $('[data-intro-skip]', brandIntro)?.addEventListener('click', finishBrandIntro);
    }
  }

  const menu = $('[data-menu]');
  const menuToggle = $('[data-menu-toggle]');
  const closeMenu = () => {
    menu?.classList.remove('is-open');
    menuToggle?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('st-menu-open');
  };
  const openMenu = () => {
    menu?.classList.add('is-open');
    menuToggle?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('st-menu-open');
  };
  menuToggle?.addEventListener('click', () => menu?.classList.contains('is-open') ? closeMenu() : openMenu());
  $('[data-menu-close]')?.addEventListener('click', closeMenu);
  $$('a', menu).forEach((link) => link.addEventListener('click', closeMenu));
  $('[data-language-unavailable]')?.addEventListener('click', (event) => {
    const notice = $('[data-language-notice]');
    if (!notice) return;
    notice.hidden = !notice.hidden;
    event.currentTarget.setAttribute('aria-expanded', String(!notice.hidden));
  });

  const cartDrawer = $('[data-cart-drawer]');
  const cartOverlay = $('[data-cart-overlay]');
  const openCart = () => {
    cartOverlay.hidden = false;
    request(window.themeRoutes.cart).then(renderCart).catch(() => {});
    requestAnimationFrame(() => { cartOverlay.classList.add('is-open'); cartDrawer.classList.add('is-open'); cartDrawer.setAttribute('aria-hidden', 'false'); });
    document.body.style.overflow = 'hidden';
  };
  const closeCart = () => {
    cartOverlay?.classList.remove('is-open'); cartDrawer?.classList.remove('is-open'); cartDrawer?.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(() => { if (cartOverlay) cartOverlay.hidden = true; }, 350);
  };
  $$('[data-cart-open]').forEach((button) => button.addEventListener('click', openCart));
  $$('[data-cart-close]').forEach((button) => button.addEventListener('click', closeCart));
  cartOverlay?.addEventListener('click', closeCart);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') { closeCart(); closeMenu(); closeWishlist?.(); } });

  const changeLine = async (key, quantity) => {
    const cart = await request(window.themeRoutes.cartChange, { method: 'POST', body: JSON.stringify({ id: key, quantity }) });
    renderCart(cart);
  };
  const renderCart = (cart) => {
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    const body = $('[data-cart-body]'); const footer = $('[data-cart-footer]'); const reserve = $('[data-cart-reserve]');
    if (!body || !footer) return;
    body.innerHTML = '';
    if (!cart.items.length) {
      body.innerHTML = '<div class="st-cart-empty">Your bag is empty / سلّتك فارغة</div>';
      footer.hidden = true; if (reserve) reserve.hidden = true; return;
    }
    footer.hidden = false; if (reserve) reserve.hidden = false;
    const template = $('#CartItemTemplate');
    cart.items.forEach((item) => {
      const node = template.content.firstElementChild.cloneNode(true);
      $('[data-line-image]', node).src = item.image || '';
      $('[data-line-title]', node).textContent = item.product_title;
      $('[data-line-variant]', node).textContent = item.variant_title === 'Default Title' ? '' : item.variant_title;
      $('[data-line-quantity]', node).textContent = item.quantity;
      $('[data-line-price]', node).textContent = money(item.final_line_price);
      $('[data-line-minus]', node).addEventListener('click', () => changeLine(item.key, Math.max(0, item.quantity - 1)));
      $('[data-line-plus]', node).addEventListener('click', () => changeLine(item.key, item.quantity + 1));
      $('[data-line-remove]', node).addEventListener('click', () => changeLine(item.key, 0));
      body.append(node);
    });
    $('[data-cart-total]').textContent = money(cart.total_price);
  };
  request(window.themeRoutes.cart).then(renderCart).catch(() => {});

  const wishlistDrawer = $('[data-wishlist-drawer]');
  const wishlistOverlay = $('[data-wishlist-overlay]');
  const wishlistBody = $('[data-wishlist-body]');
  const wishlistEmpty = $('[data-wishlist-empty]');
  const wishlistItems = (() => {
    try {
      const parsed = JSON.parse(readStorage('localStorage', 'st-wishlist') || '[]');
      return Array.isArray(parsed) ? parsed.map((item) => typeof item === 'object' ? item : { id: String(item) }) : [];
    } catch { return []; }
  })();
  const wishes = new Map(wishlistItems.map((item) => [String(item.id), item]));
  const wishlistData = (button) => ({
    id: String(button.dataset.wishlistProduct),
    title: button.dataset.wishlistTitle || 'NO NAME OBJECT',
    url: button.dataset.wishlistUrl || window.themeRoutes.collections || '/',
    image: button.dataset.wishlistImage || '',
    price: button.dataset.wishlistPrice || ''
  });
  const saveWishes = () => writeStorage('localStorage', 'st-wishlist', JSON.stringify([...wishes.values()]));
  const renderWishlist = () => {
    const count = wishes.size;
    $$('[data-wishlist-count]').forEach((node) => { node.textContent = count; node.hidden = count === 0; });
    $$('[data-wishlist-heading-count]').forEach((node) => { node.textContent = String(count).padStart(2, '0'); });
    $$('[data-wishlist-product]').forEach((button) => button.classList.toggle('is-active', wishes.has(String(button.dataset.wishlistProduct))));
    if (!wishlistBody || !wishlistEmpty) return;
    wishlistBody.innerHTML = '';
    wishlistEmpty.hidden = count > 0;
    [...wishes.values()].forEach((item, index) => {
      const row = document.createElement('article');
      row.className = 'st-wishlist-item';
      const link = document.createElement('a');
      link.href = item.url || '/collections/all';
      if (item.image) { const img = document.createElement('img'); img.src = item.image; img.alt = item.title || ''; img.width = 180; img.height = 240; link.append(img); }
      const copy = document.createElement('span');
      const marker = document.createElement('small'); marker.textContent = `SAVED / ${String(index + 1).padStart(2, '0')}`;
      const title = document.createElement('b'); title.textContent = item.title || 'NO NAME OBJECT';
      const price = document.createElement('strong'); price.textContent = item.price || '';
      copy.append(marker, title, price); link.append(copy);
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = '×'; remove.setAttribute('aria-label', `Remove ${item.title || 'item'} from wishlist`);
      remove.addEventListener('click', () => { wishes.delete(String(item.id)); saveWishes(); renderWishlist(); });
      row.append(link, remove); wishlistBody.append(row);
    });
  };
  const openWishlist = () => {
    renderWishlist(); wishlistOverlay.hidden = false;
    requestAnimationFrame(() => { wishlistOverlay.classList.add('is-open'); wishlistDrawer.classList.add('is-open'); wishlistDrawer.setAttribute('aria-hidden', 'false'); });
    $$('[data-wishlist-toggle]').forEach((button) => button.setAttribute('aria-expanded', 'true'));
    document.body.style.overflow = 'hidden';
  };
  const closeWishlist = () => {
    wishlistOverlay?.classList.remove('is-open'); wishlistDrawer?.classList.remove('is-open'); wishlistDrawer?.setAttribute('aria-hidden', 'true');
    $$('[data-wishlist-toggle]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    document.body.style.overflow = '';
    setTimeout(() => { if (wishlistOverlay) wishlistOverlay.hidden = true; }, 350);
  };
  $$('[data-wishlist-toggle]').forEach((button) => button.addEventListener('click', openWishlist));
  $$('[data-wishlist-close]').forEach((button) => button.addEventListener('click', closeWishlist));
  wishlistOverlay?.addEventListener('click', closeWishlist);
  $$('[data-wishlist-product]').forEach((button) => {
    const id = String(button.dataset.wishlistProduct);
    if (wishes.has(id) && !wishes.get(id).title) wishes.set(id, wishlistData(button));
    button.addEventListener('click', (event) => {
      event.preventDefault(); event.stopPropagation();
      wishes.has(id) ? wishes.delete(id) : wishes.set(id, wishlistData(button));
      saveWishes(); renderWishlist();
    });
  });
  renderWishlist();

  $$('[data-product-root]').forEach((root) => {
    const variants = JSON.parse($('[data-product-json]', root)?.textContent || '[]');
    const form = $('[data-product-form]', root);
    const idInput = $('[data-variant-id]', form);
    const addButton = $('[data-add-to-cart]', form);
    const selectedOptions = () => $$('[data-option-index]', form).map((fieldset) => $('.is-selected', fieldset)?.dataset.optionValue);
    const setVariant = () => {
      const options = selectedOptions();
      const variant = variants.find((entry) => entry.options.every((value, index) => value === options[index]));
      if (!variant) { addButton.disabled = true; return; }
      idInput.value = variant.id;
      addButton.disabled = !variant.available;
      $('[data-add-label]', addButton).textContent = variant.available ? 'ADD TO BAG' : 'SOLD OUT';
      $('[data-add-sub]', addButton).textContent = variant.available ? 'زيد للسلة' : 'نفد الستوك';
      const live = $('[data-variant-live]', root); if (live) live.textContent = variant.available ? 'AVAILABLE NOW' : 'SOLD OUT';
      const status = $('[data-variant-status]', root); if (status) status.textContent = variant.available ? 'READY TO ADD' : 'PICK ANOTHER SIZE';
      $('[data-add-price]', addButton).textContent = money(variant.price);
      $('[data-product-price]', root).innerHTML = money(variant.price) + (variant.compare_at_price > variant.price ? `<s>${money(variant.compare_at_price)}</s>` : '');
      history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
    };
    $$('[data-option-value]', form).forEach((button) => button.addEventListener('click', () => {
      $$('[data-option-value]', button.closest('fieldset')).forEach((item) => item.classList.remove('is-selected'));
      $$('[data-option-value] small', button.closest('fieldset')).forEach((item) => { item.textContent = 'CHOOSE'; });
      button.classList.add('is-selected'); $('small', button).textContent = 'LOCKED'; setVariant();
    }));
    form?.addEventListener('submit', async (event) => {
      event.preventDefault(); const error = $('[data-form-error]', form); addButton.disabled = true;
      try { await request(window.themeRoutes.cartAdd, { method: 'POST', body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] }) }); error.hidden = true; openCart(); }
      catch (err) { error.textContent = err.message; error.hidden = false; }
      finally { addButton.disabled = false; }
    });

    const gallery = $('[data-gallery]', root); const track = $('[data-gallery-track]', gallery); const slides = $$('[data-media-index]', gallery); let index = 0; let startX = 0;
    const show = (next) => { if (!slides.length) return; index = (next + slides.length) % slides.length; track.style.transform = `translateX(${document.documentElement.dir === 'rtl' ? index * 100 : index * -100}%)`; slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index)); $$('[data-gallery-thumb]', gallery).forEach((thumb, i) => thumb.classList.toggle('is-active', i === index)); const current = $('[data-gallery-current]', gallery); if (current) current.textContent = String(index + 1).padStart(2, '0'); gallery.classList.add('is-interacting'); clearTimeout(gallery._timer); gallery._timer = setTimeout(() => gallery.classList.remove('is-interacting'), 1100); };
    $('[data-gallery-prev]', gallery)?.addEventListener('click', () => show(index - 1));
    $('[data-gallery-next]', gallery)?.addEventListener('click', () => show(index + 1));
    $$('[data-gallery-thumb]', gallery).forEach((thumb) => thumb.addEventListener('click', () => show(Number(thumb.dataset.galleryThumb))));
    gallery?.addEventListener('pointerdown', (event) => { startX = event.clientX; gallery.classList.add('is-interacting'); });
    gallery?.addEventListener('pointerup', (event) => { const delta = event.clientX - startX; if (Math.abs(delta) > 35) show(index + (delta < 0 ? 1 : -1)); });
    gallery?.addEventListener('click', (event) => { if (window.matchMedia('(hover: none), (pointer: coarse)').matches && event.target.closest('.st-gallery-slide img')) show(index + 1); });
    gallery?.addEventListener('touchstart', () => gallery.classList.add('is-interacting'), { passive: true });
  });

  $$('[data-hero-3d]').forEach((hero) => {
    if (hero.classList.contains('no-3d')) return;
    hero.addEventListener('pointermove', (event) => { const box = hero.getBoundingClientRect(); hero.style.setProperty('--ry', `${((event.clientX - box.left) / box.width - .5) * 14}deg`); hero.style.setProperty('--rx', `${-((event.clientY - box.top) / box.height - .5) * 8}deg`); });
    hero.addEventListener('pointerleave', () => { hero.style.setProperty('--ry', '0deg'); hero.style.setProperty('--rx', '0deg'); });
  });

  const checkoutForm = $('[data-cod-checkout-form]');
  checkoutForm?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const error = $('[data-checkout-error]');
    const submit = $('button[type="submit"]', checkoutForm);
    const form = new FormData(checkoutForm);
    const phone = String(form.get('phone') || '').replace(/\D/g, '');
    const configuredEndpoint = String(checkoutForm.dataset.orderEndpoint || '').trim().replace(/\/+$/, '');
    const endpoint = configuredEndpoint.endsWith('/order') ? configuredEndpoint : `${configuredEndpoint}/order`;
    if (!checkoutForm.reportValidity()) return;
    if (!/^\d{8}$/.test(phone)) {
      error.textContent = 'رقم الهاتف لازم يكون 8 أرقام بعد +216.'; error.hidden = false; return;
    }
    if (!configuredEndpoint || !configuredEndpoint.startsWith('https://')) {
      error.textContent = 'Cloudflare order endpoint is not connected yet. اربط الحساب الجديد من Theme settings.'; error.hidden = false; return;
    }
    submit.disabled = true; error.hidden = true;
    try {
      const cart = await request(window.themeRoutes.cart);
      if (!cart.items.length) throw new Error('سلّتك فارغة.');
      const attemptStorageKey = `noNameOrderAttempt:${cart.token || 'cart'}`;
      const state = String(form.get('governorate') || '');
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          idempotencyKey: orderAttemptId(attemptStorageKey),
          customerName: String(form.get('name') || ''),
          email: '',
          phoneLocal: phone,
          state,
          city: state,
          address: String(form.get('address') || ''),
          note: '',
          website: String(form.get('website') || ''),
          attribution: (() => { try { return JSON.parse(readStorage('localStorage', checkoutAttributionKey) || '{}'); } catch { return {}; } })(),
          cartToken: cart.token,
          items: cart.items.map((item) => ({
            variantId: item.variant_id,
            productTitle: item.product_title,
            variantTitle: item.variant_title,
            quantity: item.quantity
          }))
        })
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || !data.ok) throw new Error(data.error || 'تعذّر تأكيد الطلبية. عاود جرّب.');
      if (!/^#\d+$/.test(String(data.orderName || ''))) throw new Error('Shopify سجّل الطلبية، أمّا رقم الطلب النهائي مازال غير متاح. عاود جرّب بعد لحظة.');
      writeStorage('sessionStorage', 'noNameLastOrder', JSON.stringify({
        orderName: data.orderName,
        orderId: data.orderId || '',
        customerName: String(form.get('name') || ''),
        state,
        address: String(form.get('address') || ''),
        totalPrice: Number(cart.total_price || 0) + Number(window.noNameDeliveryFeeCents || 700),
        currency: cart.currency || 'TND',
        items: cart.items.map((item) => ({ title: item.product_title, variant: item.variant_title, quantity: item.quantity, image: item.image || '', price: item.final_line_price })),
        createdAt: Date.now()
      }));
      removeStorage('sessionStorage', attemptStorageKey);
      await request(window.themeRoutes.cartClear, { method: 'POST', body: '{}' });
      $$('[data-cart-count]').forEach((el) => { el.textContent = '0'; });
      const successUrl = `${window.themeRoutes.cartPage || '/cart'}?view=order-success&order=${encodeURIComponent(data.orderName)}`;
      window.location.assign(successUrl);
    } catch (err) {
      error.textContent = err.message; error.hidden = false;
    } finally { submit.disabled = false; }
  });

  const successRoot = $('[data-order-success]');
  if (successRoot) {
    let snapshot = {};
    try { snapshot = JSON.parse(readStorage('sessionStorage', 'noNameLastOrder') || '{}'); } catch { snapshot = {}; }
    const queryOrder = new URLSearchParams(window.location.search).get('order') || '';
    const orderName = /^#\d+$/.test(queryOrder) ? queryOrder : /^#\d+$/.test(String(snapshot.orderName || '')) ? snapshot.orderName : '';
    const orderTarget = $('[data-success-order-number]', successRoot);
    if (orderTarget) orderTarget.textContent = orderName || 'CONFIRMED';
    const loyaltyNote = $('[data-loyalty-order-note]', successRoot);
    if (loyaltyNote) loyaltyNote.value = `No Name member joined after order ${orderName || 'confirmed order'}`;
    $('[data-copy-order]', successRoot)?.addEventListener('click', async (event) => {
      if (!orderName) return;
      try {
        await navigator.clipboard.writeText(orderName);
        event.currentTarget.textContent = 'COPIED ✓';
      } catch { event.currentTarget.textContent = orderName; }
    });
  }
})();
